<template>
  <div>
    <template v-if="!value">
      <v-layout row wrap v-if="option === 'btn'">
        <v-flex xs6>
          <template>
            <v-btn style="width: -webkit-fill-available;" outline :color="borderColor">
              All
            </v-btn>
          </template>
        </v-flex>
        <v-flex xs6>
          <template>
            <v-btn style="width: -webkit-fill-available;" outline :color="borderColor">
              Sale
            </v-btn>
          </template>
        </v-flex>
        <v-flex xs6 v-for="(category, i) in categories" :key="i">
          <template>
            <v-btn style="width: -webkit-fill-available;" outline :color="borderColor">
              {{ category.name }}
            </v-btn>
          </template>
        </v-flex>
      </v-layout>
      <v-tabs slider-color="primary" class="pa-2" v-if="option === 'tab'">
        <v-tab ripple> {{ $t('All') }} </v-tab>
        <v-tab ripple> {{ $t('Sale') }} </v-tab>
        <v-tab ripple v-for="(category, i) in categories" :key="i">
          {{ category.name }}
        </v-tab>
      </v-tabs>
      <div style="display: flex; overflow: auto;" v-if="option === 'image'">
        <v-flex>
          <v-card class="ml-2 mr-2" style="width: 110px; cursor: pointer">
            <v-responsive :aspect-ratio="1">
              <div
                :style="
                  `background-size:contain;background-image: url('${images[0]['0']}');height: 100%;background-position: center;background-size: cover;`
                "
              ></div>
            </v-responsive>
            <div class="pa-2">
              <div class="primary--text">ทั้งหมด</div>
            </div>
          </v-card>
        </v-flex>
        <v-flex>
          <v-card class="ml-2 mr-2" style="width: 110px; cursor: pointer">
            <v-responsive :aspect-ratio="1">
              <div
                :style="
                  `background-size:contain;background-image: url('${images[1]['1']}');height: 100%;background-position: center;background-size: cover;`
                "
              ></div>
            </v-responsive>
            <div class="pa-2">
              <div class="primary--text">ลดราคา</div>
            </div>
          </v-card>
        </v-flex>
        <v-flex v-for="(category, i) in categories" :key="i">
          <v-card class="ml-2 mr-2" style="width: 110px; cursor: pointer">
            <v-responsive :aspect-ratio="1">
              <div
                :style="
                  `background-size:contain;background-image: url('${
                    images[i][category.id]
                  }');height: 100%;background-position: center;background-size: cover;`
                "
              ></div>
            </v-responsive>
            <div class="pa-2">
              <div class="primary--text">{{ category.name }}</div>
            </div>
          </v-card>
        </v-flex>
      </div>
    </template>
    <v-layout wrap v-if="productsItem">
      <template v-for="(item, k) in productsItem">
        <v-flex :key="k" v-if="item ? item.status : false" xs6 sm6 md6 lg6 xl6 class="mb-2">
          <v-card style="height: 100%" class="ma-2">
            <div class="soldout-tag" v-if="isOutOfStock(item)">
              <div class="text">{{ $t('Sold Out') }}</div>
            </div>
            <div>
              <v-responsive :aspect-ratio="1">
                <div
                  :style="
                    `background-size:contain;background-image: url('${
                      item.photourl
                        ? item.photourl.split(';;')[0]
                        : '/static/img/assets/_global/default-photo.png'
                    }');height: 100%;background-position: center;background-size: cover;`
                  "
                ></div>
              </v-responsive>
            </div>
            <div
              class="text-xs-center sale-tag caption"
              v-if="discountPercentage(item) > 0"
              style="position: absolute; right: 5px; top: 0"
            >
              {{ $t('Sale') }}
              <br />
              {{ discountPercentage(item) | numberFormat }}%
            </div>
            <div class="pa-2">
              <div style="word-break: break-word;" class="mt-2">{{ item.name }}</div>
              <!-- <small>{{ item.description }}</small> -->

              <div
                v-if="
                  item.productstock &&
                    item.productstock.length &&
                    item.productstock[item.productstock.length - 1][4] !== item.productstock[0][4]
                "
                :style="`color:${selectedBot.shopcolor}`"
              >
                ฿{{ item.productstock[0][4] }} - ฿{{
                  item.productstock[item.productstock.length - 1][4]
                }}
              </div>
              <div v-else :style="`color:${selectedBot.shopcolor}`">฿{{ item.discountprice }}</div>
            </div>
            <!-- <v-divider></v-divider>
            <div>
              <v-card-text style="height: 98px;overflow-y: auto;">
                <div v-for="stock in item.productstock" :key="stock[0]" class="mb-3">
                  <v-layout row wrap>
                    <v-flex xs6>
                      <div>{{ stock[3] }}</div>
                      <div class="caption">{{ stock[1] }}</div>
                    </v-flex>
                    <v-flex xs6 style="white-space: nowrap;">
                      <small>ลดเหลือ</small> <span class="py-2 primary--text">{{ stock[4] }}</span>
                    </v-flex>
                  </v-layout>
                </div>
              </v-card-text>
            </div> -->
          </v-card>
        </v-flex>
      </template>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['value', 'option', 'categories', 'images', 'borderColor'],
  computed: {
    ...mapGetters({
      products: 'getProducts',
      selectedBot: 'selectedBot'
    }),

    productsItem() {
      var result = []
      if (this.value) {
        this.value.map(item => {
          result.push(this.products.filter(value => value.id === item)[0])
        })
      }
      return this.value ? result : this.products
    }
  },
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {
    discountPercentage: function(item) {
      var max = 0

      for (let index = 0; index < item.productstock.length; index++) {
        var price =
          item.productstock[index][3] == null || item.productstock[index][3] == ''
            ? parseFloat(item.price)
            : parseFloat(item.productstock[index][3])
        var discountprice =
          item.productstock[index][4] == null || item.productstock[index][4] == ''
            ? price
            : parseFloat(item.productstock[index][4])

        if (index == 0) {
          max = ((price - discountprice) / price) * 100
        } else {
          var percent = ((price - discountprice) / price) * 100
          if (max < percent) {
            max = percent
          }
        }
      }

      return max
    },

    isOutOfStock: function(item) {
      var a = 0
      for (let index = 0; index < item.productstock.length; index++) {
        a += JSON.parse(item.productstock[index][2])
      }
      return a === 0 ? true : false
    }
  }
}
</script>

<style lang="scss" scoped>
.sale-tag {
  display: inline-block;
  padding: 10px;
  color: white;
  background: #ff4c00;
  margin-right: 10px;
  position: relative;
}
.soldout-tag {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;

  .text {
    top: 50%;
    position: absolute;
    margin-top: -9px;
    color: white;
    left: 0;
    text-align: center;
    right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/salePage/templateType/ProductList.vue